import { useEffect } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useDispatch } from 'react-redux';
import { getTpHistory } from '../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';
import Loader3D from '../../../../components/Loader/Loader3D';

const TpDetails = ({ open, setOpen, rowDetails }) => {
  const { loading, tpHistory } = useSelector((store) => store.crd);
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      dispatch(getTpHistory(rowDetails?.trainer_id));
    }
  }, [open]);
  return (
    <GlobalDialog
      maxWidth={'md'}
      fullWidth
      title={'TP History'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <Box
              sx={{
                maxHeight: 400,
                overflowY: 'auto',
                border: '1px solid #ccc',
                borderRadius: 1,
              }}
            >
              <Table
                size="small"
                sx={{
                  minWidth: 650,
                  '& th, & td': {
                    textAlign: 'center',
                    border: '1px solid #ddd',
                    padding: '8px',
                  },
                }}
              >
                <thead>
                  <TableRow sx={{ background: '#f5f5f5' }}>
                    <TableCell sx={{ fontWeight: 'bold' }}>CRO Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Admission No</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Student</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Subject</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>TP</TableCell>
                  </TableRow>
                </thead>

                <tbody>
                  {tpHistory?.length ? (
                    tpHistory.map((item) => (
                      <TableRow key={item.expense_id}>
                        <TableCell>{item.name || 'Nill'}</TableCell>
                        <TableCell>{item.admn_no}</TableCell>
                        <TableCell>{item.student_name}</TableCell>
                        <TableCell>{item.subject_name}</TableCell>
                        <TableCell>{item?.ledger_tp}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} style={{ textAlign: 'center', padding: 20 }}>
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </tbody>
              </Table>
            </Box>
          )}
        </>
      }
    />
  );
};

export default TpDetails;
